export default __webpack_public_path__ + "static/media/bones.a5e4771a.svg";